<template>
    <div class="login fullBg">
        <div class="userList">
            <div class="itemList" v-for="item in loginList" :key="item.id" @click="loginSuccessFn(item)">
                <div class="loginBox " :class="selectedName==item.name?'big':''">
                    <img src="../assets/img/loginUserBg.png" alt="" class="userBg">
                    <!--                    <span class="loginImg"><img src="../assets/img/bossImg.png" alt=""></span>-->
                    <span class="loginImg"><img :src="item.avatar" alt=""></span>
                    <span class="loginName">
                        <i class="name">{{ item.name }}</i>
                        <i class="position">{{ item.title ? getPost(item.title, 'zh') : '' }}</i>
                        <!--                        <i class="position PingFang">中赫北控足球俱乐部总经理</i>-->
                    </span>
                </div>
            </div>
        </div>
        <!--        <button style="position: fixed;left: 0" @click="test">测试点击</button>-->
    </div>
</template>

<script>
export default {
    name: 'login',
    computed: {
        lookCommandFn() {
            return this.$store.state.paramsCommand;
        }
    },
    watch: {
        lookCommandFn: {
            handler(val, old) {
                let loginList = this.loginList;//球员list
                let flag = 0;

                for (let j = 0; j < loginList.length; j++) {
                    if (eval('/' + loginList[j].name + '/gi').test(val)) {
                        this.$store.dispatch("setFlag", '4_' + new Date().getTime());//vuex改变识别信息
                        let routerObj = {
                            path: '/about/main_btn',
                            name: 'main_btn',
                            goType: 1
                        }
                        this.$store.dispatch("setRouter", routerObj);//vuex改变路由
                        this.$store.dispatch("setUserName", loginList[j].name);//vuex改变路由
                        this.$store.state.userTit = loginList[j].title ? this.getPost(loginList[j].title, 'zh') : '';
                        this.selectedName = loginList[j].name;
                        this.$store.state.userId = loginList[j].id;
                        flag = 1;
                        return false;
                    } else {
                        flag = 0;
                    }
                }
                if (!flag) {
                    this.$store.dispatch("setFlag", '0_' + new Date().getTime());//vuex改变识别信息
                } else {
                    let time = null;
                    time = setTimeout(() => {
                        this.$parent.triggerAiDate = new Date();
                        let routerObj = {
                            path: '/about/main_btn',
                            name: 'main_btn',
                            goType: 1
                        }
                        this.$store.dispatch("setRouter", routerObj);//vuex改变路由

                    }, 2000)
                }
            },
            deep: true
        },
    },
    data() {
        return {
            userData: this.$route.params,//登录userid
            loginList: [],//需要登录的列表
            timer: null,//定时器

            selectedName: '',//选中的人名
            titleList: [],
        }
    },
    mounted() {
        this.getTitle();
        this.info();
    },
    methods: {
        // 获取职位列表
        getTitle() {
            this.$server
                .commonDataTit({
                    key: "title",
                })
                .then((res) => {
                    if (res.code === 200) {
                        this.titleList = res.data;
                    }
                });
        },
        // 职位中英文切换
        getPost(key, lang) {
            let item = this.titleList.find(item => item.key === key);
            return item ? (lang === 'en' ? item.valueEn : item.value) : key;
        },
        info() {
            // console.log(this.userData.data)
            if (this.userData.data && this.userData.data.length) {

                this.loginList = this.userData.data;

                if (this.loginList.length > 1) {  //exe打开，自动播放音频选择登录的用户提示
                    this.$store.dispatch("setFlag", '6_' + new Date().getTime());//vuex改变识别信息
                }
                if (this.loginList.length == 1) {  //exe打开，自动播放音频选择登录的用户提示
                    this.$store.dispatch("setUserName", this.loginList[0].name);//vuex改变路由
                    this.$store.state.userTit = this.loginList[0].title ? this.getPost(this.loginList[0].title, 'zh') : '';
                    console.log(this.$store.state.userTit)
                    this.$store.state.userId = this.loginList[0].id;
                    let bigName = null;
                    bigName = setTimeout(() => {
                        this.selectedName = this.loginList[0].name;
                    }, 1000)
                    let time = null;
                    time = setTimeout(() => {
                        this.$store.dispatch("setFlag", '4_' + new Date().getTime());//vuex改变识别信息
                        this.$parent.triggerAiDate = new Date();
                        let routerObj = {
                            path: '/teams',
                            name: 'teams',
                            goType: 1
                        }
                        this.$store.dispatch("setRouter", routerObj);//vuex改变路由

                    }, 2000)
                } else {
                    clearInterval(this.timer)
                    this.timer = setInterval(() => {//20秒 查询一次时间，判断是否在登录页面停留了两分钟以上
                        if (new Date() - this.userData.time > 120000) {
                            this.$router.push({
                                path: '/',
                                name: 'Home'
                            })
                        }
                    }, 20000)
                }
            }
        },
        loginSuccessFn(data) {
            this.$store.dispatch("setUserName", data.name);//vuex改变路由
            this.$store.state.userTit = data.title ? data.title : '';
            this.$store.state.userId = data.id;
            this.$parent.triggerAiDate = new Date();
            this.$router.push({
                path: '/about/main_btn',
                name: 'main_btn'
            });
        },
        test() {
            this.$parent.audioPlayFn(this.$global.audioPlayUrl(this.$global.randomFn(this.$aiJson.playVoice.loginMsg)), true)

        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
    }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.fullBg {
    background-image: url("../assets/img/updateImg/bg2.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.login {
    text-align: center;
    color: #fff;
    /*background: red;*/
}

.userList {
    margin-top: 10%;
    padding-right: 6%;
    padding-left: 6%;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    .itemList {
        width: 33.3%;
        text-align: center;
        display: inline-block;
        //padding-right: 2%;
        //padding-left: 2%;
        box-sizing: border-box;
        height: 100%;

        .loginBox {
            width: 84%;
            height: 70%;
            display: inline-block;
            position: relative;
            transition: all 0.6s; /*所有属性变化在0.6秒内执行动画*/

            .userBg {
                position: absolute;
                left: 0;
                top: 0;
                z-index: 10;
                width: 100%;
            }

            em {
                position: absolute;
                bottom: -30%;
                z-index: 200;
                width: 0;
                height: 0;

            }

            &:hover {
                transform: scale(1.2); /*鼠标放上之后元素变成1.2倍大小*/
            }
        }

        .big {
            transform: scale(1.2); /*鼠标放上之后元素变成1.2倍大小*/
        }

        .loginImg {
            //height: 29vw;
            overflow: hidden;
            display: inline-block;
            text-align: left;
            transform: skewX(-9deg);
            width: 68%;
            height: 83%;
            margin-top: 8%;
            position: relative;
            background: #000000;
            box-shadow: 20px 30px 40px rgba(0, 0, 0, 0.4), -30px 10px 40px rgba(124, 56, 254, 0.4);

            img {
                position: absolute;
                bottom: 0;
                width: 100%;
                transform: skewX(9deg);
            }
        }

        .loginName {
            position: absolute;
            left: 16%;
            bottom: 15%;
            z-index: 300;
            height: 5vw;
            width: 100%;
            text-align: left;

            i {
                font-style: normal;
                display: block;
            }

            .name {
                font-size: 40px;
            }

            .position {
                padding-top: .5vw;
                font-size: 24px;
            }
        }

    }
}
</style>
